import { sessaoFetch } from '@/service/fetch'

export async function list () {
  return sessaoFetch(`base`, `/regra?all=1`, 'GET')
}



// WEBPACK FOOTER //
// ./src/api/permissao.js